import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import CommentsView from './view';

import { decryptText } from '@library/enc-dec';
import { handleCommentReply } from '@helpers/ReplyInputbox';

import * as CommentsService from '@services/Comments';

import {
	updateCommentLikeCount,
	updateCommentDislikeCount,
	updateCommentStatusChange,
	updateReplyLikeCount,
	updateReplyDislikeCount,
	updateReplyStatusChange,
	updateCommentReply,
} from '@helpers/comments';

function Comments(props) {
	const { id } = useParams();

	const [userDetails, setUserDetails] = useState(null);
	const [apiCommentData, setApiCommentData] = useState({});
	const [noCommentsFound, setNoCommentsFound] = useState(false);

	//START : UseState for published, heldForReview, rejected
	const [commentsData, setCommentData] = useState({});

	//END : END for published, heldForReview, rejected

	//START : Usestate for sort
	const sortContainerRef = useRef(null);
	const [sortContainerVisiable, setSortContainerVisiable] = useState(false); // In init the container is not visiable

	useEffect(() => {
		if (id !== undefined) {
			// Get the data of a given user id
			const userId = id;
			getComments(userId);
		} else {
			setNoCommentsFound(true);
		}

		document.addEventListener('mousedown', handleOutsideClick);

		return () => {
			document.removeEventListener('mousedown', handleOutsideClick);
		};
	}, []);

	const getComments = async (userId) => {
		// Get the data of a given user id
		try {
			// Getting all the comments
			let authToken = decryptText(localStorage.getItem('aEmediat'));
			const response = await CommentsService.getUserAllComments(userId, authToken);

			if (response.success) {
				setUserDetails(response.userDetails);
				setApiCommentData(response);
				setCommentData(response);
				return;
			}
			setNoCommentsFound(true);
		} catch (err) {
			console.log('Error coming while getting comments', err);
		}
	};

	//Fn to handle hiding of popup's when clicked outside the respective container
	const handleOutsideClick = (event) => {
		if (
			sortContainerRef.current &&
			!sortContainerRef.current.contains(event.target)
		) {
			setSortContainerVisiable(false);
		}
	};

	// START : fn for sorting
	const handleSortingData = (event, sortType) => {
		setSortContainerVisiable(true);
		if (Object.keys(commentsData).length > 0) {
			if (sortType === 'newestFirst') {
				let temp = [...commentsData.data].sort(
					(a, b) => new Date(b.createdAt) - new Date(a.createdAt)
				);

				let sortedComments = {};
				sortedComments.success = apiCommentData.success;
				sortedComments.data = temp;
				setCommentData(sortedComments);
				setSortContainerVisiable(false);
			}

			if (sortType === 'top') {
				// This is sort bt likes
				let temp = [...commentsData.data].sort(
					(a, b) => b.likesCount - a.likesCount
				);

				let sortedComments = {};
				sortedComments.success = apiCommentData.success;
				sortedComments.data = temp;
				setCommentData(sortedComments);
				setSortContainerVisiable(false);
			}
		}
	};
	// END : fn for sorting

	const handleLikeComment = async (userComment) => {
		try {
			let payload = {
				commentId: userComment._id,
				videoDocId: userComment.videoDocId,
			};
			let authToken = decryptText(localStorage.getItem('aEmediat'));
			const response = await CommentsService.likeComment(payload, authToken);

			if (response.success) {
				// Status tells that increase likes count
				let status = response.data ? true : false;
				let updatedComments = updateCommentLikeCount(
					commentsData,
					userComment._id,
					status
				);

				setCommentData(updatedComments);

				// Updating already fetched api data
				let updatedApiData = updateCommentLikeCount(
					apiCommentData,
					userComment._id,
					status
				);

				setApiCommentData(updatedApiData);
			}
		} catch (err) {
			console.log('Error coming while handling comment', err);
		}
	};

	const handleDislikeComment = async (userComment) => {
		try {
			let payload = {
				commentId: userComment._id,
				videoDocId: userComment.videoDocId,
			};
			let authToken = decryptText(localStorage.getItem('aEmediat'));
			const response = await CommentsService.dislikeComment(payload, authToken);

			if (response.success) {
				// Status tells that increase likes count
				let status = response.data ? true : false;
				let updatedComments = updateCommentDislikeCount(
					commentsData,
					userComment._id,
					status
				);

				setCommentData(updatedComments);

				// Updating already fetched api data
				let updatedApiData = updateCommentDislikeCount(
					apiCommentData,
					userComment._id,
					status
				);

				setApiCommentData(updatedApiData);
			}
		} catch (err) {
			console.log('Error coming while handling comment', err);
		}
	};

	const handleCommentStatus = async (status, commentId) => {
		try {
			let payload = {
				commentId: commentId,
				status: status,
			};
			let authToken = decryptText(localStorage.getItem('aEmediat'));

			const response = await CommentsService.updateCommentStatus(
				payload,
				authToken
			);

			if (response.success) {
				const { _id, status } = response.data;
				// Updating current filtered set
				let updatedComments = updateCommentStatusChange(commentsData, _id, status);
				setCommentData(updatedComments);

				// Updating already fetched api data
				let updatedApiData = updateCommentStatusChange(apiCommentData, _id, status);

				setApiCommentData(updatedApiData);
			}
		} catch (err) {
			console.log('Error coming while handling comments status update', err);
		}
	};

	const handleReplyLike = async (userReply, videoDocId) => {
		try {
			let payload = {
				replyId: userReply._id,
				commentId: userReply.commentId,
				videoDocId: videoDocId,
			};

			let authToken = decryptText(localStorage.getItem('aEmediat'));
			const response = await CommentsService.likeReply(payload, authToken);
			if (response.success) {
				// Status tells that increase likes count
				let status = response.data ? true : false;
				let updatedComments = updateReplyLikeCount(
					commentsData,
					userReply.commentId,
					userReply._id,
					status
				);

				setCommentData(updatedComments);

				// Updating already fetched api data
				let updatedApiData = updateReplyLikeCount(
					apiCommentData,
					userReply.commentId,
					userReply._id,
					status
				);

				setApiCommentData(updatedApiData);
			}
		} catch (err) {
			console.log('Error coming while handling reply like', err);
		}
	};

	const handleReplyDislike = async (userReply, videoDocId) => {
		try {
			let payload = {
				replyId: userReply._id,
				commentId: userReply.commentId,
				videoDocId: videoDocId,
			};
			let authToken = decryptText(localStorage.getItem('aEmediat'));
			const response = await CommentsService.dislikeReply(payload, authToken);
			if (response.success) {
				// Status tells that increase dislikes count
				let status = response.data ? true : false;
				let updatedComments = updateReplyDislikeCount(
					commentsData,
					userReply.commentId,
					userReply._id,
					status
				);

				setCommentData(updatedComments);

				// Updating already fetched api data
				let updatedApiData = updateReplyDislikeCount(
					apiCommentData,
					userReply.commentId,
					userReply._id,
					status
				);

				setApiCommentData(updatedApiData);
			}
		} catch (err) {
			console.log('Error coming while handling reply dislike', err);
		}
	};

	const handleReplyStatus = async (status, replyId) => {
		try {
			let authToken = decryptText(localStorage.getItem('aEmediat'));
			let payload = {
				replyId: replyId,
				status: status,
			};
			const response = await CommentsService.updateReplyStatus(payload, authToken);

			if (response.success) {
				const { _id, commentId, status } = response.data;

				// Updating current filtered set
				let updatedComments = updateReplyStatusChange(
					commentsData,
					commentId,
					_id,
					status
				);

				setCommentData(updatedComments);

				// Updating already fetched api data
				let updatedApiData = updateReplyStatusChange(
					apiCommentData,
					commentId,
					_id,
					status
				);

				setApiCommentData(updatedApiData);
			}
		} catch (err) {
			console.log('Error coming while handling reply status', err);
		}
	};

	const handleAddingCommentReply = async (reply, docId) => {
		try {
			let authToken = decryptText(localStorage.getItem('aEmediat'));
			let payload = {
				commentId: docId,
				reply: reply,
			};
			const response = await CommentsService.addReply(payload, authToken);
			if (response.success) {
				const updatedComments = updateCommentReply(
					commentsData,
					docId,
					response.data
				);

				setCommentData(updatedComments);

				let updatedApiData = updateCommentReply(
					apiCommentData,
					docId,
					response.data
				);

				setApiCommentData(updatedApiData);
			}
		} catch (err) {
			console.log('Error coming while adding reply', err);
		}
	};

	const handleAddingReplyOfReply = async (reply, docId, commentId) => {
		try {
			let authToken = decryptText(localStorage.getItem('aEmediat'));
			let payload = {
				replyOnId: docId,
				commentId: commentId,
				reply: reply,
			};
			const response = await CommentsService.addReplyOfReply(payload, authToken);

			if (response.success) {
				const updatedComments = updateCommentReply(
					commentsData,
					commentId,
					response.data
				);

				setCommentData(updatedComments);

				let updatedApiData = updateCommentReply(
					apiCommentData,
					commentId,
					response.data
				);

				setApiCommentData(updatedApiData);
			}
		} catch (err) {
			console.log('Error coming while adding reply', err);
		}
	};

	const handleAddReply = (reply, docId, replyType, commentId) => {
		if (replyType === 'replyOnComment') {
			handleAddingCommentReply(reply, docId);
		} else {
			handleAddingReplyOfReply(reply, docId, commentId);
		}
	};

	return (
		<>
			<CommentsView
				noCommentsFound={noCommentsFound}
				commentsData={commentsData}
				//START : UseState * fn for published, heldForReview, rejected
				commentAction={handleCommentStatus}
				//START : UseState & fn for sorting
				sortContainerRef={sortContainerRef}
				sortContainerVisiable={sortContainerVisiable}
				handleSortingData={handleSortingData}
				handleLikeComment={handleLikeComment}
				handleDislikeComment={handleDislikeComment}
				// Handling Replies
				handleReplyLike={handleReplyLike}
				handleReplyDislike={handleReplyDislike}
				handleReplyStatus={handleReplyStatus}
				handleCommentReply={(event, commentId, replyType) =>
					handleCommentReply(
						event,
						commentId,
						replyType,
						userDetails,
						handleAddReply
					)
				}
			/>
		</>
	);
}

export default Comments;
